import ClientList from '../layout/Cashier/ClientList'
import { clientStatus, TypesStatusListFilter } from '../../data/data-products'
import DropdownBtn from '../ui/DropdownBtn'
import OptionsList from '../layout/OptionsList'
import { useDispatch, useSelector } from 'react-redux'
import { selectedClientStatusLabel, selectedIsOpenOptionStatus, setIsBooleanType, setSelectedClientStatus } from '../../features/client/clientSlice'
import ClientOptionSorting from '../common/option-sorting/ClientOptionSorting'

export default function ClientModule() {

    const dispatch = useDispatch()
    const selectedStatusLabel = useSelector(selectedClientStatusLabel)
    const isOpenOption = useSelector(selectedIsOpenOptionStatus)

    const onSelect = (value: TypesStatusListFilter) => {
        const id = value.id;
        const name = value.label;
        dispatch(setSelectedClientStatus({id, label: name}))
    }

    return (
        <div className='bg-white rounded-md w-full h-full p-4 flex-1 flex flex-col space-y-3 overflow-hidden'>
            <ClientOptionSorting/>
            <div className='flex justify-between items-end'>
                <div className='relative inline-block w-[120px]'>
                    <DropdownBtn
                        label={selectedStatusLabel}
                        isOpen={isOpenOption}
                        setIsOpenStatus={() => dispatch(setIsBooleanType({ type: 'openOptionStatus', value: !isOpenOption}))}
                    />
                    {isOpenOption && (
                        <OptionsList
                            options={clientStatus}
                            onSelect={onSelect}
                            onHide={() => dispatch(setIsBooleanType({ type: 'openOptionStatus', value: false}))}
                        />
                    )}
                </div>
            </div>
            <ClientList 
                sortOptionClient={selectedStatusLabel}
            />
        </div>
    )
}
